/** Ordered dashboard sections — reorder this array to change layout without touching widget internals */
export const CRM_DASHBOARD_SECTION_ORDER = ["kpis", "workflowMetrics", "taskPanels", "analytics", "timeline"] as const;

export type CrmDashboardSectionId = (typeof CRM_DASHBOARD_SECTION_ORDER)[number];
